import React, {
  useState,
  useRef,
  useEffect,
  lazy,
  Suspense,
  memo,
  useCallback,
  useMemo,
} from 'react';
import { connect } from 'react-redux';
const Modal = lazy(() => import('@components/common/Modal'));
const FullWithModal = lazy(() =>
  import('@components/common/Modal/FullWidthModal')
);
import Loader from '@components/common/Loader/newLoaderModal';
const PhoneNumberComponent = lazy(() =>
  import('@components/common/PhoneNumberComponent/indexRevamp')
);
import Keyboard from '@components/KeyboardV2';
import { getObjectValue, deconstructStringUrl } from '@utility/utills';
import { flowType } from '../../utility/userInfo';
import { getFormatedPhoneNumber } from '@utility/helperFunction';
import { CUSTOM_MESSAGES, LABEL } from '../../veriables';
import { Formik, Form } from 'formik';
import { ReactComponent as Cross } from '@assets/images/cross.svg';
import cn from 'classnames';
import style from './checksCommon.module.css';
import { TouchableButton, TouchableDiv } from '../common/Touchable/index';

const ReceiptScreenPopUp = props => {
  // Props Destructuring
  const {
    type,
    handleReceipt,
    isOpen,
    onClose,
    countryCode,
    phoneNumberMaxLength,
    handleCountryCodeChange,
    setInputs,
    inputs,
    setError,
    isLandScape,
    serverAppTheme,
    orderingPortraitOrientation,
  } = props;

  // State Management
  const [isLink, setIsLink] = useState({ isOpen: false, link: '' });
  const [loader, setLoader] = useState(false);
  const [disclamer, setDisclamer] = useState('');
  const iframeRef = useRef(null);
  const storeInfo = useMemo(
    () =>
      getObjectValue(
        () => JSON.parse(window.sessionStorage.getItem('auth')),
        {}
      ),
    []
  );
  const loyaltyData = useMemo(
    () =>
      getObjectValue(
        () =>
          JSON.parse(window.sessionStorage.getItem('loyaltyData')) ||
          JSON.parse(window.sessionStorage.getItem('giftCardReceiptData')),
        ''
      ),
    []
  );
  const counterPhoneNumber = useMemo(
    () =>
      getObjectValue(
        () => window.sessionStorage.getItem('counterPhoneNumber'),
        ''
      ),
    []
  );
  const [linkList, setLinkList] = useState([]);
  const timeoutId = useRef(null);
  const isServerApp = flowType() === 'serverApp';
  const isKiosk = flowType() === 'kiosk';
  const [inputName, setInputName] = useState(type);
  const [keyboardType, setKeyboardType] = useState(
    type === 'email' ? 'textWithNumericEmail' : 'numericWithBin'
  );
  const [typed, setTyped] = useState({});
  const ref = useRef(null);
  const typedRef = useRef(typed);
  const inputsRef = useRef(inputs);
  const onCloseRef = useRef(onClose);
  typedRef.current = typed;
  inputsRef.current = inputs;
  onCloseRef.current = onClose;
  const tickets = useMemo(() => {
    try {
      const seatData = window.sessionStorage.getItem('seat');
      return seatData ? JSON.parse(seatData) : null;
    } catch (e) {
      return null;
    }
  }, []);

  // React Hooks
  useEffect(() => {
    const disclamers =
      type === 'phone'
        ? storeInfo.loyaltyInfo.smsOptInDisclaimer || ''
        : storeInfo.loyaltyInfo.emailOptInDisclaimer || '';
    if (disclamers?.length > 0) {
      const [link, concatChar] = deconstructStringUrl(disclamers);
      setLinkList(link);
      setDisclamer(concatChar.split('¿'));
    }
  }, [type]);

  useEffect(() => {
    if (ref.current) {
      setInputs({
        ...inputs,
        [inputName]: inputs[inputName],
      });
      ref.current.input = {
        ...inputs,
        [inputName]: replaceAll(inputs[inputName], '-'),
      };
    }
  }, [isOpen]);
  const closeKeyboard = useCallback(() => {
    onCloseRef.current();
  }, []);
  // Methods

  const handleLink = useCallback(
    text => {
      const index = linkList.findIndex(d => d === text);
      const link = linkList[index + 1];
      setIsLink({ isOpen: true, link });
      setLoader(true);
      timeoutId.current = setTimeout(() => {
        clearTimeout(timeoutId.current);
        setLoader(false);
      }, 30000);
    },
    [linkList]
  );

  const handleBlur = () => {
    const element = document.querySelector(`#${type}`);
    element.blur();
  };

  const getInputValue = inputNameDat => {
    return inputs[inputNameDat] || '';
  };
  const onChangeInput = event => {
    const inputVal = event.target.value;
    setInputName(type);
    if (ref.current) {
      ref.current.setInput(inputs[inputName], inputVal);
    }
  };
  const onClickBtn = useCallback(e => {
    const typed = typedRef.current;
    const inputs = inputsRef.current;
    setError('');
    if (
      e !== '{bksp}' &&
      type === 'phone' &&
      Number(phoneNumberMaxLength) > 0 &&
      (typed[inputName] || '').split('-').join('').length >= Number(phoneNumberMaxLength)
    ) {
      return;
    }
    const value =
      e === '{bksp}'
        ? { ...typed, [inputName]: typed[inputName]?.slice(0, -1) }
        : {
          ...typed,
          [inputName]: typed[inputName]
            ? typed[inputName].concat(e)
            : ''.concat(e),
        };
    setTyped(value);
    setInputs({
      ...inputs,
      [inputName]:
        inputName === 'phone' && Number(countryCode) === 1
          ? getFormatedPhoneNumber(value[inputName])
          : value[inputName],
    });
  }, [inputName, countryCode, setError, setInputs]);

  const handleClear = useCallback(() => {
    setError('');
    setInputs({ ...inputs, [inputName]: '' });
    setTyped({ ...inputs, [inputName]: '' });
  }, [inputName]);

  const handleSetInputEmpty = useCallback(() => {
    setInputs({ ...inputsRef.current, [type]: '' });
    setTyped({ ...typedRef.current, [inputName]: '' });
  }, [type, inputName, setInputs]);

  const { emailAddress = null, phoneNumber = null } = loyaltyData || {};
  const {
    smsOptInDefaultUnselected = null,
    emailOptInDefaultUnselected = null,
  } = storeInfo?.loyaltyInfo || {};
  const formikInitialValues = useMemo(
    () => ({
      email: emailAddress,
      phone: phoneNumber || counterPhoneNumber,
      optIn:
        type === 'phone'
          ? !smsOptInDefaultUnselected
          : !emailOptInDefaultUnselected,
    }),
    [
      emailAddress,
      counterPhoneNumber,
      type,
      phoneNumber,
      smsOptInDefaultUnselected,
      emailOptInDefaultUnselected,
    ]
  );

  const handleDomainSelect = domain => {
    const currentValue = typed[inputName] || '';
    const localPart = currentValue.includes('@');

    const updatedValue = localPart
      ? `${currentValue.split('@')[0]}${domain}`
      : `${currentValue}${domain}`;

    setTyped({
      ...typed,
      [inputName]: updatedValue,
    });

    setInputs({
      ...inputs,
      [inputName]:
        inputName === 'phone' && Number(countryCode) === 1
          ? getFormatedPhoneNumber(updatedValue)
          : updatedValue,
    });
  };

  return (
    <>
      <Suspense fallback={<Loader />}>
        <FullWithModal
          isOpen={isOpen}
          isModalCenter
          customClass2={cn(
            'w-100 h-100 position-relative',
            style.fullWidthModal
          )}
          noBackground
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            height: '100%',
            pointerEvents: 'auto',
            backgroundColor: serverAppTheme?.popUp_bg,
            backgroundClip: 'padding-box',
            border: '0',
            boxShadow: serverAppTheme?.popUp_box_shadow,
          }}
        >
          <div className={cn('col-12 px-0 h-100')}>
            <div
              style={{
                backgroundColor: serverAppTheme?.popUp_bg,
                boxShadow: serverAppTheme?.popUp_box_shadow,
                color: serverAppTheme?.primary_text,
              }}
              className={cn(
                'px-0 h-100',
                type === 'email' ? '' : 'h-100',
                'col-12'
              )}
            >
              <div className={cn('col-12 px-2 d-flex', style.moretitlebg ,orderingPortraitOrientation ? 'py-1' : '')}>
                <div className={cn("col-4 p-0",orderingPortraitOrientation? 'fs_16' : '')}>
                  {tickets?.tab ? 'Tab' : 'Table'}:
                  {tickets?.stationName?.length > 8
                    ? tickets?.stationName.substring(0, 8) + '...'
                    : tickets?.stationName}
                </div>
                <div className="col-4 p-0 text-center">
                  {type === 'email'
                    ? CUSTOM_MESSAGES().CHK_RS_EMAIL_RECEIPT_TITLE
                    : CUSTOM_MESSAGES().CHK_RS_TEXT_RECEIPT_TITLE}
                </div>
                <div className={cn("col-4 p-0 text-right",orderingPortraitOrientation? 'fs_16' : '')}>#{tickets?.number}</div>
              </div>

              <div
                className={cn(
                  'd-flex  justify-content-center align-items-end',
                  !isLandScape && 'col-12' ,orderingPortraitOrientation ? 'h-30 px-12' : 'px-3'
                )}
              >
                {isOpen && (
                  <Formik
                    enableReinitialize
                    initialValues={formikInitialValues}
                    onSubmit={data =>
                      handleReceipt({
                        ...data,
                        email: type === 'email' && inputs.email,
                        phone: type === 'phone' && inputs.phone,
                        optIn:
                          storeInfo.loyaltyInfo.optInMethods.length > 0 &&
                          storeInfo.loyaltyInfo.optInMethods.includes(type) &&
                          data.optIn,
                        accountNumber: loyaltyData?.accountNumber || null,
                      })
                    }
                  >
                    {() => {
                      return (
                        <div
                          className={cn(
                           orderingPortraitOrientation ? 'px-0' : 'px-2',
                            isLandScape ? 'col-10' : 'col-12'
                          )}
                        >
                          <Form>
                            <div
                              className={cn(
                                'col-12 px-0',
                                type === 'phone' && 'pt-3',
                                storeInfo.loyaltyInfo.optInMethods.length > 0 &&
                                  storeInfo.loyaltyInfo.optInMethods.includes(
                                    type
                                  ) &&
                                  (type === 'phone'
                                    ? storeInfo.loyaltyInfo.smsOptInDisclaimer
                                    : storeInfo.loyaltyInfo
                                      .emailOptInDisclaimer) &&
                                  storeInfo.loyaltyInfo.supportsOptIn
                                  ? 'my-2'
                                  : 'my-4'
                              )}
                            >
                              <div className={cn("h-15 position-relative",orderingPortraitOrientation ? 'pb-12' : '')}>
                                {type === 'phone' && (
                                  <PhoneNumberComponent
                                    countryCode={countryCode}
                                    styles={{
                                      left: 0,
                                      padding: 'p-2',
                                    }}
                                    isCustomWidth="fs-32"
                                    handleCountryCodeChange={e => {
                                      setError('');
                                      handleCountryCodeChange(e);
                                      handleClear();
                                    }}
                                    maxMenuHeight={200}
                                    isLandScape={isLandScape}
                                    screenType="textReceipt"
                                    serverAppTheme={serverAppTheme}
                                  />
                                )}
                                <input
                                  id={type}
                                  type="text"
                                  name={type}
                                  className={cn(
                                    'col-12 form-control rounded-0',
                                    type === 'phone' ? '' : 'text-left',
                                    style.input
                                  )}
                                  style={{
                                    height: isLandScape
                                      ? type === 'email'
                                        ? '44px'
                                        : '64px'
                                      : '64px',
                                    border: 'none',
                                    fontSize: isServerApp
                                      ? isLandScape
                                        ? '26px'
                                        :(orderingPortraitOrientation ?'24px'  :'22px')
                                      : '20px',
                                    background: serverAppTheme?.inputBg,
                                    borderBottom:
                                      serverAppTheme?.inputBorder_Bottom,
                                    color: serverAppTheme?.primary_text,
                                    '--placeholder-color':
                                      serverAppTheme?.input_placeholder,
                                    fontFamily: 'Poppins',
                                    fontWeight: orderingPortraitOrientation ? 400 : 500,
                                   paddingLeft:type === 'phone'  ? (orderingPortraitOrientation ? '30vw' : '19vw') : (orderingPortraitOrientation ? '12px' : ''),
                                  }}
                                  placeholder={
                                    type === 'phone'
                                      ? 'Enter Phone Number'
                                      : 'Enter Email Address'
                                  }
                                  value={getInputValue(type)}
                                  onFocus={e => {
                                    handleBlur();
                                    onChangeInput(e);
                                    setKeyboardType(
                                      type === 'email'
                                        ? 'textWithNumericEmail'
                                        : 'numericWithBin'
                                    );
                                  }}
                                />
                                {typed[inputName]?.length > 0 && (
                                  <TouchableDiv
                                    role="presentation"
                                    className="position-absolute"
                                    style={{
                                      right: '18px',
                                      top: type === 'email' ? orderingPortraitOrientation ? '15px': '7px' : '1rem',
                                    }}
                                    onClick={() => {
                                      setInputs({
                                        ...inputs,
                                        [inputName]: '',
                                      });
                                      setTyped({
                                        ...typed,
                                        [inputName]: '',
                                      });
                                    }}
                                  >
                                    <Cross
                                      fill={serverAppTheme?.iconcolor}
                                      alt="cross"
                                      className=""
                                      aria-hidden="true"
                                    />
                                  </TouchableDiv>
                                )}
                              </div>
                              {storeInfo.loyaltyInfo.optInMethods.length > 0 &&
                                storeInfo.loyaltyInfo.optInMethods.includes(
                                  type
                                ) &&
                                (type === 'phone'
                                  ? storeInfo.loyaltyInfo.smsOptInDisclaimer
                                  : storeInfo.loyaltyInfo
                                    .emailOptInDisclaimer) &&
                                storeInfo.loyaltyInfo.supportsOptIn && (
                                  <div
                                    className={cn(
                                      'col-12 row mx-0 justify-content-start pb-0 px-0 pt-2 fs-18 overflowY align-items-start '
                                    )}
                                  >
                                    <div
                                      className={cn(
                                        'mb-auto d-flex align-items-center justify-content-center'
                                      )}
                                    >
                                      <input
                                        className={cn(style.receiptCheckbox)}
                                        type="checkbox"
                                        name={'optIn'}
                                        onChange={() => { }}
                                        style={{
                                          '--checkbox-border': `2px solid ${props?.serverAppTheme?.primary_text}`,
                                          '--checkbox-checked-color':
                                            serverAppTheme?.checkbox_check_color,
                                          '--checkbox-checked-bg':
                                            serverAppTheme?.checkbox_checked,
                                        }}
                                      />
                                    </div>
                                    <div className="col-11 pl-3 pr-0 d-inline flex-wrap fs-16 text-left">
                                      {disclamer?.length > 0 &&
                                        disclamer?.map(text => {
                                          return text.startsWith('#?') ? (
                                            <>
                                              &nbsp;
                                              <span
                                                role="presentation"
                                                onClick={() =>
                                                  text.startsWith('#?') &&
                                                  handleLink(
                                                    text.replace('#?', '')
                                                  )
                                                }
                                                className="text-underline "
                                                style={{
                                                  color:
                                                    props?.serverAppTheme
                                                      ?.link_color,
                                                }}
                                              >
                                                {text.replace('#?', '')}
                                              </span>
                                              &nbsp;
                                            </>
                                          ) : (
                                            <>{text}</>
                                          );
                                        })}
                                    </div>
                                  </div>
                                )}
                            </div>
                            <div
                              className={cn("d-flex mx-auto justify-content-center position-fixed", orderingPortraitOrientation ? 'col-12 px-12' :'col-8')}
                              style={{
                                bottom: '8px',
                                left: !orderingPortraitOrientation ? '16.7%' : '0px',
                              }}
                            >
                              <div className="col-6 pl-0 pr-1">
                                <TouchableButton
                                  type="button"
                                  className={cn(
                                    'px-0 mb-2 mt-2 pl-2 rounded btn-ripple fs_24 fw-600 w-100',orderingPortraitOrientation ? 'btn68' : 'btn44'
                                  )}
                                  onClick={e => {
                                    e.preventDefault();
                                    onClose();
                                  }}
                                  style={{
                                    backgroundColor:
                                      serverAppTheme?.OFF_Premise_Btn,
                                    border: serverAppTheme?.cancleBtn_Border,
                                    color: serverAppTheme?.cancleBtn_font,
                                  }}
                                  rippleEffect={true}
                                >
                                  {LABEL().CANCEL}
                                </TouchableButton>
                              </div>
                              <div
                                className={cn(
                                  'col-6 pl-1 pr-0 mt-2 my-2 d-flex justify-content-center align-items-center text-center',
                                  style.outline
                                )}
                              >
                                <TouchableButton
                                  className={cn(
                                    isLandScape ? 'col-12' : 'col-12 px-0',
                                    'px-0 btn-ripple border-0 btn44'
                                  )}
                                  type="submit"
                                  style={{
                                    backgroundColor:
                                      serverAppTheme?.secondaryBtn,
                                    color: serverAppTheme?.btn_font_color,
                                    height: (!isLandScape && orderingPortraitOrientation) ?  '7.5vh' : '',
                                  }}
                                  rippleEffect={true}
                                >
                                  <div
                                    className={cn(
                                      'd-flex justify-content-center align-items-center',
                                      !isLandScape && 'fs-32'
                                    )}
                                  >
                                    {LABEL().KDS_DROP_CONTINUE}
                                  </div>
                                </TouchableButton>
                              </div>
                            </div>
                          </Form>
                        </div>
                      );
                    }}
                  </Formik>
                )}
              </div>
            </div>

            {/* Email Entry with Common Domain Pills */}
            {type === 'email' && (
              <div
                className={cn(
                  'd-flex flex-row o-group-menu overflowX w-100 overflowY align-items-center py-2 position-absolute pl-2',orderingPortraitOrientation ? 'flex-wrap' :'',
                )}
                style={{
                  bottom: orderingPortraitOrientation? '165px' : '60px',
                  gap:orderingPortraitOrientation ? '10px' : ''
                }}
              >
                {storeInfo?.emailDomainNames.map(domain => {
                  return (
                    <button
                      className={cn(
                        style.oUnselectedGroupBg,
                        'w-auto text-nowrap px-3 mx-1 fs_16 fw-500  rounded-pill py-1'
                      )}
                      key={domain}
                      onClick={() => handleDomainSelect(domain)}
                      style={{
                        color: serverAppTheme?.primary_text,
                        border: `1px solid ${serverAppTheme?.modifiers_border}`,
                      }}
                    >
                      {domain}
                    </button>
                  );
                })}
              </div>
            )}

            <div
              className={cn('col-12  position-fixed' ,orderingPortraitOrientation ? 'px-12' :'px-0')}
              style={{ bottom: type === 'email' ? (orderingPortraitOrientation ? '270px' : '110px') :(orderingPortraitOrientation ? '260px' : '68px'), left: '0' }}
            >
              {isOpen && (type === 'email' || type === 'phone') && (
                <Keyboard
                  setKeyboardType={setKeyboardType}
                  onClickBtn={onClickBtn}
                  type={keyboardType}
                  closeKeyboard={closeKeyboard}
                  btnSize={isKiosk ? 'btn44' : 'btn44 fs-30'}
                  isDot
                  isDone={true}
                  customClass={
                    !isLandScape ? 'rounded-bottom p-1' : `fs-30 p-2`
                  }
                  spacebtn={!isLandScape && style.spacebtn}
                  setinputEmpty={handleSetInputEmpty}
                  screenType="textreceiptPopUp"
                />
              )}
            </div>
          </div>
        </FullWithModal>
      </Suspense>

      <Suspense fallback={<Loader />}>
        <Modal isOpen={isLink?.isOpen}>
          <div className="col-12 p-2 text-right">
            <i
              role="presentation"
              className="fa fa-times od-text-primary text-primary fs-26"
              onClick={() => setIsLink({ isOpen: false, link: '' })}
            />
          </div>
          {loader && <Loader />}
          {isLink?.isOpen && (
            <iframe
              title="iframe"
              src={isLink?.link || ''}
              scrolling="auto"
              toolbar="0"
              ref={iframeRef}
              style={{
                width: '100%',
                height: 'calc(84vh)',
                border: '0',
              }}
              onLoad={() => {
                clearTimeout(timeoutId.current);
                setLoader(false);
              }}
              onError={e => {
                clearTimeout(timeoutId.current);
                setLoader(false);
              }}
              referrerPolicy="strict-origin-when-cross-origin"
            />
          )}
        </Modal>
      </Suspense>
    </>
  );
};

const mapStateToProps = ({ theme }) => ({
  serverAppTheme: theme.serverAppTheme,
});

const MemoisedReceiptPopUp = memo(ReceiptScreenPopUp);
export default connect(mapStateToProps)(MemoisedReceiptPopUp);
